var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSwap = function SvgSwap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5L12.5 11H11.375C11.2295 11 11.0971 11.0842 11.0354 11.2159C10.9737 11.3477 10.9938 11.5033 11.0869 11.6151L12.9619 13.8651C13.0332 13.9506 13.1387 14 13.25 14C13.3613 14 13.4668 13.9506 13.5381 13.8651L15.4131 11.6151C15.5062 11.5033 15.5263 11.3477 15.4646 11.2159C15.4029 11.0842 15.2705 11 15.125 11H14V0.5H12.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00001 15.5L2.00001 5H0.875008C0.729508 5 0.597132 4.91583 0.535407 4.78406C0.473682 4.65229 0.493783 4.49671 0.586933 4.38493L2.46193 2.13493C2.53318 2.04943 2.63871 2 2.75001 2C2.86131 2 2.96683 2.04943 3.03808 2.13493L4.91308 4.38493C5.00623 4.49671 5.02633 4.65229 4.96461 4.78406C4.90288 4.91583 4.77051 5 4.62501 5H3.50001L3.50001 15.5H2.00001Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSwap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swap.3e8c1f52.svg";
export { ForwardRef as ReactComponent };